import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { SCRIPT_ATTR_ALLOWED } from './DynamicScript.constants';
export function iifeWrapper(body) {
  return "\n  (function () {".concat(body, "})();\n  ");
}
export function getAdditionalScriptProps(restProps) {
  var attrKeys = Object.keys(restProps);
  if (attrKeys.length === 0) {
    return {};
  }
  return attrKeys.reduce(function (props, key) {
    if (SCRIPT_ATTR_ALLOWED.includes(key) || key.startsWith('data-')) {
      return _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, key, restProps[key]));
    }
    return props;
  }, {});
}